import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Car } from '../../models/car';

@Injectable({
    providedIn: 'root'
})
export class TaskService {
    private searchNumberSubject = new Subject<Car>();
    public searchNumber = this.searchNumberSubject.asObservable();

    constructor() { }

    public searchTask(car: Car) {
        this.searchNumberSubject.next(car);
    }
}